export default __webpack_public_path__ + "static/media/ic_matic_16new.f3ef2852.svg";